import { CaseType } from '@brands/services/cases/types/ICase';
import { Button } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { GoTriangleDown } from 'react-icons/go';

import useCases from '../../../../hooks/useCases';
import ConsulationHistory from '../ConsultationHistory/ConsulationHistory';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';

import styles from './styles.module.scss';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';

interface Modal {
  patient_id: number;
  isMobile?: boolean;
  currentCaseId: number;
  patient_name: string;
}

const PatientCasesList = ({
  patient_id,
  isMobile: _isMobile = false,
  currentCaseId,
  patient_name,
}: Modal): JSX.Element => {
  const [displayedCases, setDisplayedCases] = useState<any[]>([]);
  const [displayCount, setDisplayCount] = useState(5);
  const { userInfo } = useAppSelector(selectAuth);
  const roleNavigate = useRoleNavigate();
  const casesparams = useMemo(
    () => ({
      sort_by: 'created_at' as const,
      sort_direction: 'desc' as const,
      status: [
        'new',
        'accepted_care_advisor',
        'accepted_provider',
        'in_progress_provider',
        'in_progress_care_advisor',
        'completed_by_provider',
        'completed',
      ],
      type: [
        CaseType.one_report,
        CaseType.second_opinion,
        CaseType.video_call_scheduled,
        CaseType.phone_call_scheduled,
        CaseType.care_coordination,
        CaseType.oral_health_coaching,
        CaseType.clinical_enablement,
      ],
      patient_id,
      limit: 5,
    }),
    [patient_id],
  );

  const casesparamsSmileScan = useMemo(
    () => ({
      sort_by: 'created_at' as const,
      sort_direction: 'desc' as const,
      status: ['completed'],
      type: [CaseType.smile_scan],
      patient_id,
      limit: 2,
    }),
    [patient_id],
  );

  const { cases, loadNextPage, hasNextPage, loading } = useCases(casesparams, true, userInfo.role.name);
  const { cases: smileScanCases } = useCases(casesparamsSmileScan, true, userInfo.role.name);

  useEffect(() => {
    if (cases.length > 0 || smileScanCases.length > 0) {
      const combinedCases = [...smileScanCases, ...cases].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
      setDisplayedCases(combinedCases);
    }
  }, [cases, smileScanCases]);

  const handleLoadMore = (): void => {
    const newDisplayCount = displayCount + 5;
    setDisplayCount(newDisplayCount);

    if (displayedCases.length < newDisplayCount && hasNextPage) {
      loadNextPage();
    }
  };

  return (
    <div className={styles.patient}>
      <div className={styles.underLinedDiv}>
        <div className={styles.flexCol}>
          {Array.from(new Map(displayedCases.map((singleCase) => [Number(singleCase.id), singleCase])).values())
            .filter((singleCase) => Number(singleCase.id) !== Number(currentCaseId))
            .map((singleCase) => (
              <ConsulationHistory key={singleCase.id} singleCase={singleCase} />
            ))}

          {displayedCases.length > 0 && (
            <Button
              variant="text"
              className={styles.patientCasesListFullHistory}
              onClick={() => roleNavigate(`/dashboard?patient_full_name=${encodeURIComponent(patient_name)}`)}
            >
              View full history
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientCasesList;
